import React from "react";
import { Button, Icon } from "@amzn/meridian";
import chevronUpLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-up-large";
import chevronDownLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-down-large";
import "./cameraControlsButton.scss";

interface CameraControlsButtonProps {
  onClick: () => void;
  direction?: "up" | "down";
}

const CameraControlsButton: React.FC<CameraControlsButtonProps> = ({ onClick, direction = "up" }) => {
  return (
    
    <div className="camera-controls-button__wrapper">
        <Button className="camera-controls-button"  type="icon" size="large" circular={true} onClick={onClick} aria-label="Camera controls">
          <Icon tokens={direction === "up" ? chevronUpLargeTokens : chevronDownLargeTokens} />
        </Button>
    </div>
  );
};

export default CameraControlsButton;
